import type { Message } from "@/reducers/messagesSlice"
import type { SearchHit } from "./searchResultParser"

export function archiveTimestampMicroseconds(timestamp: string): number {
  const fraction = timestamp.match(/\.(\d+)(?:Z|[+-]\d{2}:\d{2})$/)?.[1] ?? ""
  return (
    Date.parse(timestamp) * 1000 + Number(fraction.padEnd(6, "0").slice(3, 6))
  )
}

export function isSearchHistoryAnchor(
  message: Message,
  hit: Pick<SearchHit["document"], "id" | "timestamp">,
): boolean {
  if (message.id === hit.id || message.originId === hit.id) return true
  // The search index ID identifies an indexed document (e.g. mike752275),
  // while MAM uses its archive ID. Search's timestamp is the archive's exact
  // microsecond timestamp; comparing only Date.parse would lose this precision.
  return archiveTimestampMicroseconds(message.timestamp) === hit.timestamp
}
